import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import { MessageMsgFrom, MessageType } from '@tencent/dz-models';
import { useMessageModel, useConsultModel } from '../../../hooks';
import styles from './style/index.less';
import copy from 'copy-to-clipboard';
import { isInWechat, isInWxWork } from '../../../utils';
var StaffOption = function (props) {
    var staffTel = props.staffTel, staffWx = props.staffWx;
    var View = useComponents().View;
    var messageModel = useMessageModel();
    var consultModel = useConsultModel();
    if (!staffTel && !staffWx) {
        return null;
    }
    var handleCopyWx = function () {
        var isIOS = navigator.userAgent.match(/(iPad|iPhone|iPod|Macintosh)/i);
        return new Promise(function (resolve) {
            // 复制微信
            if (navigator.clipboard && isIOS) {
                navigator.clipboard.writeText(staffWx || '').then(function () {
                    resolve(true);
                });
            }
            else {
                copy(staffWx || '');
                resolve(true);
            }
        }).then(function () {
            messageModel.pushMessage({
                type: MessageType.SystemCustom,
                msg_from: MessageMsgFrom.FmcSystem,
                payload: {
                    message: '微信号已复制，请前往微信添加',
                },
            });
            jumpToWx();
        });
    };
    // 调起微信
    var jumpToWx = function () {
        // 首先判断是否在微信内(不包括企微)
        if (isInWechat() && !isInWxWork())
            return;
        // 微信跳转
        consultModel.transferMessage(JSON.stringify({
            type: 'jump',
            url: 'weixin://',
        }), function () { return (window.location.href = 'weixin://'); });
    };
    var handleCall = function () {
        consultModel.transferMessage(JSON.stringify({
            type: 'tel',
            url: staffTel,
        }), function () { return (window.location.href = "tel:" + staffTel); });
    };
    return (React.createElement(View, { className: styles['staff-option'] + " " + styles['server-answer'] },
        staffWx && (React.createElement(View, { className: styles['staff-option-btn'] + " " + styles['staff-option-btn-wx'], onClick: handleCopyWx }, "\u6DFB\u52A0\u5FAE\u4FE1")),
        staffTel && (React.createElement(View, { className: styles['staff-option-btn'] + " " + styles['staff-option-btn-tel'], onClick: handleCall }, "\u7535\u8BDD\u54A8\u8BE2"))));
};
export default StaffOption;
